import {
  SET_INVESTMENT_INFORMATION,
  SET_SELECTED_INVESTMENT_INFORMATION,
  SET_INVESTMENT_ENTITY_INFORMATION,
  SET_INVESTMENT_TYPE_INFORMATION,
  GET_CLIENT_INFORMATION,
  SET_PROJECTION_API_RESPONSE,
  SET_PROJECTION_MODEL,
  SET_INVESTMENT_CHART_MODEL,
  SET_COMPARE_INVESTMENTS_INFO,
} from "../../../helpers/vuex-constants";
import { InvestmentService } from "../../../services";
import Investment from "../../../models/investment";

export default {
  setInvestmentInformation: {
    root: true,
    async handler(context, payload) {
      try {
        if (context.state.investmentdata && !context.state.investmentdata[0]) {
          const response = await InvestmentService.getInvestmentInformation(
            payload.clientId,
            payload.entityType
          );
          const apidata = response.data;
          if (response.status == 200 && apidata.length >= 1) {
            context.commit(
              SET_INVESTMENT_INFORMATION,
              Investment.setInvestmentInformation(
                apidata,
                context.rootGetters[GET_CLIENT_INFORMATION]
              )
            );
          } else {
            context.commit(SET_INVESTMENT_INFORMATION, []);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async setAllInvestmentInformation(context, payload) {
    context.commit(SET_INVESTMENT_INFORMATION, payload);
  },
  async [SET_SELECTED_INVESTMENT_INFORMATION](context, payload) {
    context.commit(SET_SELECTED_INVESTMENT_INFORMATION, payload);
  },
  async [SET_COMPARE_INVESTMENTS_INFO](context, payload) {
    context.commit(SET_COMPARE_INVESTMENTS_INFO, payload);
  },
  async setProjectionModel(context, payload) {
    context.commit(SET_PROJECTION_MODEL, payload);
  },
  async setInvestmentDefaultModel(context, payload) {
    if (payload && payload.length > 0) {
      context.commit(SET_INVESTMENT_INFORMATION, payload);
    }
    context.commit(
      SET_INVESTMENT_ENTITY_INFORMATION,
      Investment.setInvestmentEntiyInformation(
        context.rootGetters[GET_CLIENT_INFORMATION]
      )
    );
    context.commit(
      SET_INVESTMENT_TYPE_INFORMATION,
      Investment.setInvestmentTypeInformation([])
    );
  },

  async setProjectionApiResponse(context, payload) {
    context.commit(SET_PROJECTION_API_RESPONSE, payload);
  },
  async setInvestmentChartModel(context, payload) {
    context.commit(SET_INVESTMENT_CHART_MODEL, payload);
  },
  async setSelectedInvestmentInformation(context, payload) {
    context.commit(SET_SELECTED_INVESTMENT_INFORMATION, payload);
  },
};
